export default __webpack_public_path__ + "static/media/hht2_ep_09.4954ddc0.png";